import {useNeoContext} from "@/context/neo/neo.context";
import {FleetService} from "@/service/fleet.service";
import React, {useEffect, useState} from "react";
import GenericWidget from "../widgets/GenericWidget";
import WidgetData from "../widgets/Widget-data";

const FuelWidget: React.FC = () => {
  const {filterContext} = useNeoContext();
  const [loginUserId, setLoginUserId] = useState("");

  useEffect(() => {
    if (filterContext?.client?.institutionUserId) {
      setLoginUserId(filterContext.client.institutionUserId);
    }
  }, [filterContext]);

  return (
    <GenericWidget
      title="Fuel Stations"
      icon="/images/fuel_yellow.svg"
      type={1}
      fetchService={FleetService.getfleetdatas}
      addService={FleetService.addfleetdata}
      updateService={FleetService.updatefleetdata}
      deleteService={FleetService.deletefleetdata}
      renderEmptyImage="/images/fuelGroup.svg"
      emptyText="No fuel station added yet"
      actionText="Fuel Station"
      WidgetContent={WidgetData}
      loginUserId={loginUserId}
      apiresponsekey="fuelStations"
    />
  );
};

export default FuelWidget;
